module.exports = __webpack_public_path__ + "assets/img/17c89a43690a2722c736b748b0b4c548.jpeg";